import { AppointmentDurationInNumbers } from '@avanta/shared/constants/appointments';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { formatEUR } from '@avanta/shared/utils/currency';
import { Tag, Tags } from 'lucide-react';
import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { type SessionPack } from 'types/packs';
import { AppointmentsReservePayload } from '../../../../types';
import { CheckboxCard } from '../../../ui/CheckboxCard';

export const Pack = ({ pack }: { pack: SessionPack }): React.ReactElement => {
  const { grantedSessions, pricePaidInEurPerSession } = pack;
  const { setValue, watch } = useFormContext();
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);

  const selectedPack = watch(AppointmentsReservePayload.selectedPack);
  const isSelected = selectedPack?.grantedSessions === pack.grantedSessions;

  const totalPrice = formatEUR(pricePaidInEurPerSession * grantedSessions);
  const pricePerSession = formatEUR(
    pricePaidInEurPerSession * AppointmentDurationInNumbers.DURATION_DOUBLE
  );

  const icon = pack.grantedSessions === AppointmentDurationInNumbers.DURATION_DOUBLE ? Tag : Tags;
  const label = (
    <Trans
      ns={LOCIZE_NS.APPOINTMENTS}
      i18nKey={`AppointmentsReserve.Steps.payment.packName.${grantedSessions}`}
      values={{
        price: totalPrice,
        pricePerSession: pricePerSession,
      }}
      components={{
        'font-normal': <span className="font-normal" />,
      }}
    />
  );

  const handleCheckedChange = (checked: boolean): void => {
    setValue(AppointmentsReservePayload.selectedPack, checked ? pack : '');
  };

  return (
    <CheckboxCard
      id={pack.grantedSessions.toString()}
      label={label}
      description={t(`AppointmentsReserve.Steps.payment.packDescription.${grantedSessions}`)}
      icon={icon}
      checked={isSelected}
      onCheckedChange={handleCheckedChange}
      className="am-lg:px-2.5 am-lg:h-30 p-4 justify-start"
    />
  );
};
